//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        live_streaming: Object
    },
    data () {
        return {
            show: false,
            living: false,
            forcoming: false,
            replay: false
        }
    },
    watch: {
        live_streaming ({ status, room_id }) {
            if (status !== '结束') {
            } else {
                this.show = false
            }
        }
    },
    computed: {
        live_url () {
            if (this.live_streaming && this.live_streaming.room_id) {
                return `plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${this.live_streaming.room_id}&close_share_ticket=1`
            }
        }
    },
    methods: {
    }
}
